import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import {
  setFirstOrderFieldAction,
  setFirstOrderNumberAction,
  setOrdersAmountAction,
  switchOrderAction,
} from '../../store/actions/order';
import {
  firstOrderNumberSelector,
  ordersAmountSelector,
} from '../../store/selectors/order';
import JointOrder from './JointOrder';

const mapStateToProps = (state) => ({
  isMobile: getIsMobile(state),
  ordersAmount: ordersAmountSelector(state),
  firstOrder: firstOrderNumberSelector(state),
});

const mapDispatchToProps = {
  setFirstOrder: setFirstOrderNumberAction,
  setOrdersAmount: setOrdersAmountAction,
  switchOrder: switchOrderAction,
  setFirstOrderField: setFirstOrderFieldAction,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(JointOrder);
